import {ChangeDetectionStrategy, Component, effect, EventEmitter, inject, input, OnInit, Output, ViewChild} from '@angular/core';
import {GMDatePipe} from "../../common/date.pipe";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatSort, MatSortModule, Sort} from "@angular/material/sort";
import {PersonBadgeComponent} from "../../common/person-picker/person-badge/person-badge.component";
import {StatusBadgeComponent} from "../../common/status-badge/status-badge.component";
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {AssignPersonComponent} from '../../common/assign-person/assign-person.component';
import {MatDialog} from '@angular/material/dialog';
import {CSService} from '../../services/cs.service';
import {environment} from '../../../environments/environment';
import {LA} from '../../../models/la';
import {findLabel} from '../../utils';
import {MatTooltip} from '@angular/material/tooltip';
import {LaService} from '../../services/la.service';

@Component({
  selector: 'app-la-table',
  imports: [
    MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule,
    MatPaginatorModule, MatIcon, MatIconButton, PersonBadgeComponent,
    StatusBadgeComponent, GMDatePipe, MatProgressSpinner, MatTooltip],
  templateUrl: './la-table.component.html',
  standalone: true,
  styleUrl: './la-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LATableComponent implements OnInit {
  displayedColumns: string[] = ['number', 'date', '_type', '_subject', '_theme', '_assignee', 'status', 'open'];
  dataSource: MatTableDataSource<LA> = new MatTableDataSource([] as LA[]);
  laService = inject(LaService);
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  @Output() openDetails: EventEmitter<string> = new EventEmitter();
  @Output() pageChange: EventEmitter<PageEvent> = new EventEmitter();
  @Output() sortChange: EventEmitter<Sort> = new EventEmitter();

  values = input.required<LA[]>();
  toBeDeleted = input<string>();
  totalItems = input<number>(0);
  pageSize = input<number>(10);

  constructor() {
    effect(() => {
      this.update();
    });
  }

  update() {
    this.dataSource.data = this.values().filter((value) => value.id !== this.toBeDeleted());
  }

  csService = inject(CSService);
  readonly dialog = inject(MatDialog);

  openDialog(la: LA): void {
    const dialogRef = this.dialog.open(AssignPersonComponent, {
      width: '400px',
      height: '100px',
      data: {},
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result && result.assignee) {
        await this.csService.updateAssignee(la.id, result.assignee);
      }
    });
  }

  ngOnInit() {
    this.update();
    setTimeout(() => {
      this.sort?.sort({id: 'date', start: 'desc', disableClear: false});
    }, 0);
  }

  onSortChange(event: Sort) {
    this.sortChange.emit(event);
  }

  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }

  protected readonly environment = environment;
  protected readonly window = window;
  protected readonly findLabel = findLabel;
}
